import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/esnext.set.add-all.js";
import "core-js/modules/esnext.set.delete-all.js";
import "core-js/modules/esnext.set.difference.js";
import "core-js/modules/esnext.set.every.js";
import "core-js/modules/esnext.set.filter.js";
import "core-js/modules/esnext.set.find.js";
import "core-js/modules/esnext.set.intersection.js";
import "core-js/modules/esnext.set.is-disjoint-from.js";
import "core-js/modules/esnext.set.is-subset-of.js";
import "core-js/modules/esnext.set.is-superset-of.js";
import "core-js/modules/esnext.set.join.js";
import "core-js/modules/esnext.set.map.js";
import "core-js/modules/esnext.set.reduce.js";
import "core-js/modules/esnext.set.some.js";
import "core-js/modules/esnext.set.symmetric-difference.js";
import "core-js/modules/esnext.set.union.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import sanitizeHtml from 'sanitize-html';
import { watchThrottled } from '@vueuse/core';
import useMobileObserver from '~/composables/useMobileObserver';
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useSearchFacets } from '~/composables/_next/useSearchFacets';
import { useSearchStore } from '~/composables/_next/stores/useSearchStore';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton.vue';
import MobileFiltersButton from '~/components/ui/CustomStoreFrontUI/MobileFiltersButton.vue';
import SearchResultsEmpty from '~/pages/legacy/SearchResults/SearchResultsEmpty.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzTabs from '~/components/_next/molecules/AzTabs.vue';
import AzTab from '~/components/_next/molecules/AzTab.vue';
import AzSidebar from '~/components/_next/molecules/AzSidebar.vue';
import AzAdviceCard from '~/components/_next/molecules/AzAdviceCard.vue';
import AzRecipeCard from '~/components/_next/molecules/AzRecipeCard.vue';
import ProductCardSkeleton from '~/assets/images/skeletons/product-card.svg?inline';
import CategoryPageHeader from '~/components/Product/Category/CategoryPageHeader.vue';
import SearchFiltersOrganism from '~/components/_next/organisms/search/SearchFiltersOrganism.vue';
import AzPagination from '~/components/_next/molecules/AzPagination.vue';
import ProductCardOrganism from '~/components/_next/organisms/ProductCardOrganism.vue';
import { useUser } from '~/composables/_next/useUser';
import { getProductPrice } from '~/utils/ProductPrice';
import { getIsNewProduct } from '~/helpers/productCardMethods';
import { gtmDiscountValue } from '~/helpers/gtm';
import { isProductInStock } from '~/utils/ProductAvailability';
import { instantScrollTo } from '~/helpers/ui/windowBehaviors';
import { cacheControl } from '~/helpers/cacheControl';
import { PageTypes } from '~/types/PageTypes';
import { TrackingPageCategory } from '~/types/TrackingPageCategory';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useSegment } from '~/composables/_next/useSegment';
import { useWait } from '~/composables/_next/useWait';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
const __nuxt_page_meta = {
  middleware: [cacheControl('public, s-maxage=1800, stale-while-revalidate=300, stale-if-error=300') // 30 minutes cache and 5 minutes stale
      ],tracking: {
        category: TrackingPageCategory.SRP
      }
}
export default /*#__PURE__*/_defineComponent({
  ...__nuxt_page_meta,__name: '_term',
  setup: function setup(__props) {
    var SearchUpsell = function SearchUpsell() {
      return import('~/components/_next/organisms/search/searchUpsell.vue');
    };
    var _useNuxt2App = useNuxt2App(),
      $trackers = _useNuxt2App.$trackers,
      i18n = _useNuxt2App.i18n;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta;
    setMeta({
      no_index: true,
      no_follow: true
    });
    ;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR,
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent;
    var route = useRoute();
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useSearchFacets = useSearchFacets(),
      facets = _useSearchFacets.facets,
      clearSearchFacets = _useSearchFacets.clearSearchFacets;
    var _useSearchStore = useSearchStore(),
      search = _useSearchStore.search,
      fetchAllSearchResults = _useSearchStore.fetchAllSearchResults,
      searchFacets = _useSearchStore.searchFacets,
      searchResults = _useSearchStore.searchResults,
      pagination = _useSearchStore.pagination,
      sorting = _useSearchStore.sorting;
    var _useUiHelpers = useUiHelpers(),
      hasPageFacetChanged = _useUiHelpers.hasPageFacetChanged;

    // TODO: Remove after Nuxt 3 migration
    onMounted(function () {
      var _useSegment = useSegment(),
        analytics = _useSegment.analytics;
      analytics.page(TrackingPageCategory.SRP, PageTypes.SRP, {
        path: route.fullPath
      });
    });
    var term = computed(function () {
      var _route$params;
      return route === null || route === void 0 ? void 0 : (_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.term;
    });
    var activeTab = ref('products');
    var tabLabels = computed(function () {
      return {
        products: pagination.value.products.count,
        recipes: pagination.value.recipes.count,
        advices: pagination.value.advices.count
      };
    });
    var headerTitle = computed(function () {
      return sanitizeHtml(i18n.tc('search-result.desktop-title', itemCount.value, {
        name: term.value
      }));
    });
    var currentPagination = computed(function () {
      var _pagination$value;
      return (_pagination$value = pagination.value) === null || _pagination$value === void 0 ? void 0 : _pagination$value[activeTab.value];
    });
    var currentFacets = computed(function () {
      var _searchFacets$value;
      return (_searchFacets$value = searchFacets.value) === null || _searchFacets$value === void 0 ? void 0 : _searchFacets$value[activeTab.value];
    });
    var currentSorting = computed(function () {
      var _sorting$value;
      return (_sorting$value = sorting.value) === null || _sorting$value === void 0 ? void 0 : _sorting$value[activeTab.value];
    });
    var selectedSort = computed(function () {
      var currentSort = currentSorting.value.selected;
      var currentSortPosition = currentSorting.value.options.findIndex(function (sort) {
        return sort.id === currentSort;
      });
      return currentSortPosition !== 0 ? currentSort : undefined;
    });
    var _useLazyAsyncData = useLazyAsyncData('search', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              startWaiter('search');
              _context.next = 3;
              return fetchAllSearchResults();
            case 3:
              endWaiter('search');
              return _context.abrupt("return", true);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))),
      pending = _useLazyAsyncData.pending;
    watchThrottled(facets, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(newV, oldV) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              startWaiter('search');
              if (hasPageFacetChanged(oldV.categories, newV.categories) || hasPageFacetChanged(oldV.page, newV.page)) {
                instantScrollTo({
                  top: 0
                });
              }
              _context2.next = 4;
              return search(activeTab.value);
            case 4:
              endWaiter('search');
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      throttle: 1000
    });
    var itemCount = computed(function () {
      var _pagination$value2, _pagination$value2$ad, _pagination$value3, _pagination$value3$re, _pagination$value4, _pagination$value4$pr;
      return ((_pagination$value2 = pagination.value) === null || _pagination$value2 === void 0 ? void 0 : (_pagination$value2$ad = _pagination$value2.advices) === null || _pagination$value2$ad === void 0 ? void 0 : _pagination$value2$ad.count) + ((_pagination$value3 = pagination.value) === null || _pagination$value3 === void 0 ? void 0 : (_pagination$value3$re = _pagination$value3.recipes) === null || _pagination$value3$re === void 0 ? void 0 : _pagination$value3$re.count) + ((_pagination$value4 = pagination.value) === null || _pagination$value4 === void 0 ? void 0 : (_pagination$value4$pr = _pagination$value4.products) === null || _pagination$value4$pr === void 0 ? void 0 : _pagination$value4$pr.count);
    });
    var sidebar = ref(null);
    /**
     * Opens the filters sidebar.
     */
    function openSidebar() {
      sidebar.value.sidebar.showModal();
    }
    /**
     * Closes the filters sidebar.
     */
    function closeSidebar() {
      sidebar.value.sidebar.close();
    }
    function setActiveTab(tab) {
      activeTab.value = tab;
    }
    function onClearFilters() {
      clearSearchFacets();
      closeSidebar();
    }
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar;
    var _useRecipesWishlists = useRecipesWishlists(),
      isInRecipesWishlists = _useRecipesWishlists.isInRecipesWishlists,
      removeRecipeFromWishlist = _useRecipesWishlists.removeRecipeFromWishlist;
    function updateRecipeWishlist(recipe) {
      if (isAuthenticated.value) {
        var wishlisted = isInRecipesWishlists(recipe.recipeId);
        if (wishlisted) {
          removeRecipeFromWishlist(recipe.recipeId);
        } else {
          toggleAddRecipeToWishlistSidebar({
            contentfulId: recipe.recipeId,
            image: recipe.photo,
            name: recipe.title
          });
        }
      } else {
        navigateToOrLogin({
          nextRoutePath: route.path,
          previousRoutePath: route.path
        });
      }
    }
    function changeSort(_x3) {
      return _changeSort.apply(this, arguments);
    }
    function _changeSort() {
      _changeSort = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(sort) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              startWaiter('search');
              _context3.next = 3;
              return search(activeTab.value, sort);
            case 3:
              endWaiter('search');
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _changeSort.apply(this, arguments);
    }
    useLazyAsyncData('search-gtm-events', function () {
      var _searchResults$value, _searchResults$value$;
      if (pending.value) return true;
      var trackedProducts = (_searchResults$value = searchResults.value) === null || _searchResults$value === void 0 ? void 0 : (_searchResults$value$ = _searchResults$value.products) === null || _searchResults$value$ === void 0 ? void 0 : _searchResults$value$.map(function (product, i) {
        var regular = getProductPrice(product).regular;
        var special = getProductPrice(product).special;
        return {
          item_id: "SKU_".concat(product.sku),
          item_sku: product.sku,
          item_name: (product === null || product === void 0 ? void 0 : product._name) || '',
          item_category: false,
          new_product: getIsNewProduct(product),
          discount: gtmDiscountValue(regular, special),
          discount_in_cents: gtmDiscountValue(regular, special, true),
          index: i + 1,
          price: regular,
          price_in_cents: Number((regular * 100).toFixed(2)),
          currency: 'EUR',
          is_in_stock: isProductInStock(product)
        };
      });
      if ((trackedProducts === null || trackedProducts === void 0 ? void 0 : trackedProducts.length) > 0) {
        $trackers.gtm.pushEvent('generic_event', {
          event_category: 'engagement',
          event_action: 'send',
          event_label: 'search',
          event_name: 'generic_event',
          search_term: term.value
        });
        $trackers.gtm.pushEvent('product_list_view', {
          event_category: 'ecommerce',
          event_action: 'impressions',
          event_name: 'view_item_list',
          ecommerce: {
            items: trackedProducts
          }
        });
        trackDynamicYieldEvent({
          name: 'view_item_list',
          properties: {
            items: trackedProducts
          }
        });
      } else {
        $trackers.gtm.pushEvent('search', {
          event_label: 'empty_search',
          event_name: 'empty_search',
          search_term: term.value
        });
      }
      return true;
    }, {
      watch: [searchResults, pending],
      server: false
    });
    var filteredParamNames = computed(function () {
      var _currentFacets$value$, _currentFacets$value, _currentFacets$value$2, _currentFacets$value$3;
      // get all query parameters that can be set from facets
      var facetAttrs = (_currentFacets$value$ = (_currentFacets$value = currentFacets.value) === null || _currentFacets$value === void 0 ? void 0 : (_currentFacets$value$2 = _currentFacets$value.flatMap(function (facet) {
        return facet.subfacets || facet;
      })) === null || _currentFacets$value$2 === void 0 ? void 0 : (_currentFacets$value$3 = _currentFacets$value$2.map(function (option) {
        return option.id;
      })) === null || _currentFacets$value$3 === void 0 ? void 0 : _currentFacets$value$3.filter(Boolean)) !== null && _currentFacets$value$ !== void 0 ? _currentFacets$value$ : [];
      return ['min-price', 'max-price'].concat(_toConsumableArray(new Set(facetAttrs)));
    });
    onMounted(function () {
      setDynamicYieldContext('OTHER', ['Search_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['Search_Page']);
    return {
      __sfc: true,
      SearchUpsell: SearchUpsell,
      $trackers: $trackers,
      i18n: i18n,
      setMeta: setMeta,
      setDynamicYieldContext: setDynamicYieldContext,
      setDynamicYieldContextSSR: setDynamicYieldContextSSR,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      route: route,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      isMobile: isMobile,
      facets: facets,
      clearSearchFacets: clearSearchFacets,
      search: search,
      fetchAllSearchResults: fetchAllSearchResults,
      searchFacets: searchFacets,
      searchResults: searchResults,
      pagination: pagination,
      sorting: sorting,
      hasPageFacetChanged: hasPageFacetChanged,
      term: term,
      activeTab: activeTab,
      tabLabels: tabLabels,
      headerTitle: headerTitle,
      currentPagination: currentPagination,
      currentFacets: currentFacets,
      currentSorting: currentSorting,
      selectedSort: selectedSort,
      pending: pending,
      itemCount: itemCount,
      sidebar: sidebar,
      openSidebar: openSidebar,
      closeSidebar: closeSidebar,
      setActiveTab: setActiveTab,
      onClearFilters: onClearFilters,
      isAuthenticated: isAuthenticated,
      navigateToOrLogin: navigateToOrLogin,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      isInRecipesWishlists: isInRecipesWishlists,
      removeRecipeFromWishlist: removeRecipeFromWishlist,
      updateRecipeWishlist: updateRecipeWishlist,
      changeSort: changeSort,
      filteredParamNames: filteredParamNames,
      AzBackToTopButton: AzBackToTopButton,
      MobileFiltersButton: MobileFiltersButton,
      SearchResultsEmpty: SearchResultsEmpty,
      AzButton: AzButton,
      AzTabs: AzTabs,
      AzTab: AzTab,
      AzSidebar: AzSidebar,
      AzAdviceCard: AzAdviceCard,
      AzRecipeCard: AzRecipeCard,
      ProductCardSkeleton: ProductCardSkeleton,
      CategoryPageHeader: CategoryPageHeader,
      SearchFiltersOrganism: SearchFiltersOrganism,
      AzPagination: AzPagination,
      ProductCardOrganism: ProductCardOrganism
    };
  }
});